// 📁 components/UserAvatar.js
import React, { useState } from "react";
import { useUser } from "../UserContext";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

const UserAvatar = () => {
  const { user, logout } = useUser();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate(); // ✅ Added for navigation

  const initial = user?.name?.charAt(0).toUpperCase() || "?";

  return (
    <div className="relative">
      {/* Avatar Button with Animation */}
      <div
        onClick={() => setOpen(!open)}
        title={user.name}
        className="cursor-pointer w-9 h-9 rounded-full bg-[#105132] text-white flex items-center justify-center font-bold 
                   hover:scale-105 hover:ring-2 hover:ring-[#3e8e41] transition-all duration-200 ease-in-out"
      >
        {initial}
      </div>

      {/* Dropdown */}
      {open && (
        <div className="absolute right-0 mt-2 w-36 bg-white border shadow-md rounded z-50">
          {/* 🧾 My Orders */}
          <button
            onClick={() => {
              setOpen(false);
              navigate("/my-orders");
            }}
            className="w-full text-left px-4 py-2 text-sm text-[#105132] hover:bg-[#f5f5f5]"
          >
            🧾 My Orders
          </button>

          {/* 🚪 Logout */}
          <button
            onClick={logout}
            className="w-full text-left px-4 py-2 text-sm text-[#105132] hover:bg-[#f5f5f5] flex items-center gap-2"
          >
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
